// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function BenefitsAdministrationImpProductRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (
      state.user_view == 'Internal' ||
      state.benefitsAdministrationImplementationCosts.totalPrice > 0
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString(
                  'product.BenefitsAdministrationImpProductRow.ProductName',
               )}
            </div>
            <div className='col-bhr2'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.benefitsAdministrationImplementationCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
